import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDialogVisible = $event)),
    modal: true,
    class: "dialog-add-action",
    header: _ctx.headerName
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        onClick: _ctx.doHideDialog,
        class: "p-button-rounded p-button-lg p-button-text p-button-secondary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        onClick: _ctx.doConfirm,
        class: "p-button-rounded p-button-lg",
        disabled: _ctx.confirmDisabled,
        autofocus: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Confirm")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      (_ctx.actionToAdd)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.actionComponent), {
            key: 0,
            actionToAdd: _ctx.actionToAdd,
            onConfirmDisabled: _ctx.updateConfirmDisabled
          }, null, 8, ["actionToAdd", "onConfirmDisabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}